module.exports = __webpack_public_path__ + "img/119.fb495cb1.jpg";